
import superagent from "superagent";
import {authorize} from "../helper/authorize-token";
import {deep_copy} from "../../lib/js-utils";

const SECURITY_SET_LOADING = "SECURITY_SET_LOADING";
const SECURITY_ADMIN_GET_ITEMS = "SECURITY_ADMIN_GET_ITEMS";
const SECURITY_ADMIN_SET_BREAKPOINTS = "SECURITY_ADMIN_SET_BREAKPOINTS";
const SECURITY_ADMIN_SETTLE = "SECURITY_ADMIN_SETTLE";
const SECURITY_USER_ADD_ITEMS = "SECURITY_USER_ADD_ITEMS";
const SECURITY_USER_GET_ITEMS = "SECURITY_USER_GET_ITEMS";
const SECURITY_CLEAR = "SECURITY_CLEAR";

const securityClear = () => {
  return dispatch => {
    dispatch({
      type: SECURITY_CLEAR,
    })
  }
}

const loadSecurityAdminItems = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SECURITY_SET_LOADING,
      loading: true,
    });
    dispatch({
      type: SECURITY_ADMIN_GET_ITEMS,
      payload: superagent
        .post("/api/security/admin-load-items")
        .use(authorize(getState()))
    })
  }
}

const addUserSecurityItems = (username, items) => {
  return dispatch => {
    dispatch({
      type: SECURITY_USER_ADD_ITEMS,
      username,
      items,
    })
  }
}

const loadUserSecurityItems = (username) => {
  return (dispatch, getState) => {
    dispatch({
      type: SECURITY_SET_LOADING,
      loading: true,
    });
    dispatch({
      type: SECURITY_USER_GET_ITEMS,
      payload: superagent
        .post("/api/security/load-user-items")
        .send({ username })
        .use(authorize(getState()))
    })
  }
}

const setSecurityBreakpoints = breakpoints => {
  return (dispatch) => {
    dispatch({
      type: SECURITY_ADMIN_SET_BREAKPOINTS,
      breakpoints,
    })
  }
}

// Remove item from 'open', and add to 'settled'.
const adminSettleItem = item => {
  return (dispatch) => {
    dispatch({
      type: SECURITY_ADMIN_SETTLE,
      item,
    })
  }
}

const calc_draw_down = user_items => {
  Object.keys(user_items).forEach(key => {
    user_items[key].draw_down_usd = 0.;
    for(let i=0; i < user_items[key].items.length; i++) {
      user_items[key].draw_down_usd +=
        parseFloat(user_items[key].items[i].metadata.amt_usd);
    }
  })
}

const add_items_to_state = (new_state, username, items, closed_items, replace=false) => {
  let key;
  if (!(username in new_state)) {
    new_state[username] = {};
  }
  const all_items = items.concat(closed_items);
  // Init all account keys
  const keys = new Set();
  for(let i=0; i < all_items.length; i++) {
    const key = all_items[i].username_index.split("_").pop();
    keys.add(key);
  }
  keys.forEach(key => {
    if (!(key in new_state[username])) {
      new_state[username][key] = { items: [], closed_items: [], draw_down_usd: 0 };
    }
    if (replace) {
      new_state[username][key].items = [];
      new_state[username][key].closed_items = [];
    }
  })

  for(let i=0; i < items.length; i++) {
    const item = items[i];
    key = item.username_index.split("_").pop();
    new_state[username][key].items.push(item);
  }
  for(let i=0; i < closed_items.length; i++) {
    const item = closed_items[i];
    key = item.username_index.split("_").pop();
    new_state[username][key].closed_items.push(item);
  }
  calc_draw_down(new_state[username]);
}

const ZERO_STATE = {
  loading: false,
  open: [],
  payments: [],
  settled: [],
  breakpoints: {},
}

const securityPurchaseReducer = (state = ZERO_STATE, action) => {
  const new_state = deep_copy(state);
  let data;

  switch(action.type) {
    case SECURITY_CLEAR:
      return ZERO_STATE;
    case SECURITY_SET_LOADING:
      new_state.loading = action.loading;
      return new_state;
    case SECURITY_ADMIN_SETTLE:
      const new_item = action.item;
      new_state.open = new_state.open.filter(item => item.id !== new_item.id);
      new_state.settled.unshift(new_item);
      return new_state;
    case SECURITY_ADMIN_GET_ITEMS + '_FULFILLED':
      data = action.payload.body.data;
      new_state.loading = false;
      new_state.open = data.open;
      new_state.payments = data.payments;
      new_state.settled = data.settled;
      return new_state;
    case SECURITY_USER_GET_ITEMS + "_FULFILLED":
      data = action.payload.body.data;
      if (data.status === "OK") {
        add_items_to_state(
          new_state, data.payload.username,
          data.payload.items, data.payload.closed_items, true);
      }
      return new_state;
    case SECURITY_USER_ADD_ITEMS:
      add_items_to_state(new_state, action.username, action.items, []);
      return new_state;
    case SECURITY_ADMIN_SET_BREAKPOINTS:
      new_state.breakpoints = action.breakpoints;
      return new_state;
    default:
      return state;
  }
}

export {
  securityPurchaseReducer, loadSecurityAdminItems, setSecurityBreakpoints,
  adminSettleItem, addUserSecurityItems, loadUserSecurityItems,
  securityClear };
